import { render, staticRenderFns } from "./AppellationComponent.vue?vue&type=template&id=9f83754c&scoped=true"
import script from "./AppellationComponent.vue?vue&type=script&lang=js"
export * from "./AppellationComponent.vue?vue&type=script&lang=js"
import style0 from "./AppellationComponent.vue?vue&type=style&index=0&id=9f83754c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f83754c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f83754c')) {
      api.createRecord('9f83754c', component.options)
    } else {
      api.reload('9f83754c', component.options)
    }
    module.hot.accept("./AppellationComponent.vue?vue&type=template&id=9f83754c&scoped=true", function () {
      api.rerender('9f83754c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/appellation/AppellationComponent.vue"
export default component.exports